<template>
  <article class="p-services">
    <section class="s-text l-1">
      <h2 v-html="text_1_h2"></h2>
      <h3 data-effect v-html="text_1_h3"></h3>
      <p data-effect v-html="text_1_p1"></p>
      <p data-effect v-html="text_1_p2"></p>
    </section>
    <section class="s-text l-1">
      <h2 v-html="text_2_h2"></h2>
      <h3 data-effect v-html="text_2_h3"></h3>
      <p data-effect v-html="text_2_p1"></p>
      <p data-effect v-html="text_2_p2"></p>
    </section>
    <Marquee />
    <Services />
    <section class="s-text l-2">
      <h2 v-html="text_3_h2"></h2>
      <p data-effect v-html="text_3_p1"></p>
    </section>
    <Footer :page="lang === 'en' ? 'Our Team' : 'Team'" link="team" />
  </article>
</template>

<script>
import axios from 'axios';
import { app, slider, webgl } from '@/utils/store';

import Marquee from '@/components/marquee/marquee.vue';
import Services from '@/components/services/services.vue';
import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Marquee,
    Services,
    Footer,
  },
  data() {
    return {
      path: '/',
      lang: app.language,
      text_1_h2: this.text_1_h2,
      text_1_h3: this.text_1_h3,
      text_1_p1: this.text_1_p1,
      text_1_p2: this.text_1_p2,
      text_2_h2: this.text_2_h2,
      text_2_h3: this.text_2_h3,
      text_2_p1: this.text_2_p1,
      text_2_p2: this.text_2_p2,
      text_3_h2: this.text_3_h2,
      text_3_p1: this.text_3_p1,
    };
  },
  created() {
    axios.get(`${this.path}json/services.json`).then((response) => {
      if (app.language === 'it') {
        this.text_1_h2 = response.data.it.text_1_h2;
        this.text_1_h3 = response.data.it.text_1_h3;
        this.text_1_p1 = response.data.it.text_1_p1;
        this.text_1_p2 = response.data.it.text_1_p2;
        this.text_2_h2 = response.data.it.text_2_h2;
        this.text_2_h3 = response.data.it.text_2_h3;
        this.text_2_p1 = response.data.it.text_2_p1;
        this.text_2_p2 = response.data.it.text_2_p2;
        this.text_3_h2 = response.data.it.text_3_h2;
        this.text_3_p1 = response.data.it.text_3_p1;
      } else {
        this.text_1_h2 = response.data.en.text_1_h2;
        this.text_1_h3 = response.data.en.text_1_h3;
        this.text_1_p1 = response.data.en.text_1_p1;
        this.text_1_p2 = response.data.en.text_1_p2;
        this.text_2_h2 = response.data.en.text_2_h2;
        this.text_2_h3 = response.data.en.text_2_h3;
        this.text_2_p1 = response.data.en.text_2_p1;
        this.text_2_p2 = response.data.en.text_2_p2;
        this.text_3_h2 = response.data.en.text_3_h2;
        this.text_3_p1 = response.data.en.text_3_p1;
      }
    });
  },
  mounted() {
    slider.next = 2;
    slider.current = 1;

    app.contact = false;

    if (webgl.pause === true) {
      webgl.app.play();
      webgl.pause = false;
    }

    document.fonts.ready.then(() => {
      slider.app.setSlide();
    });

    document.getElementById('a-logo').style.pointerEvents = '';
    document.getElementById('a-slider').style.visibility = 'inherit';
  },
};
</script>
